var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", [
    _c("li", [_vm._v(" " + _vm._s(_vm.$t("lbl_tax_number_rule_1")) + " ")]),
    _c("li", [_vm._v(" " + _vm._s(_vm.$t("lbl_tax_number_rule_2")) + " ")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }